import { render, staticRenderFns } from "./ChatService.vue?vue&type=template&id=d76b4b96&"
import script from "./ChatService.vue?vue&type=script&lang=js&"
export * from "./ChatService.vue?vue&type=script&lang=js&"
import style0 from "./ChatService.vue?vue&type=style&index=0&id=d76b4b96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports